

















import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { RequestStatuses } from "@/data/status";

@Component
export default class ProvisionRequestStatus extends Vue {
  // Props

  @Prop({ required: true })
  public statusCode!: string;

  @Prop({ default: "is-right" })
  public position!: string;

  @Prop({ default: "is-small" })
  public size!: string;

  @Prop({ default: true })
  public active!: boolean;

  // Computed

  public get status() {
    return _.get(RequestStatuses, `${this.statusCode}`, "");
  }
}
